import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot } from "vue";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAccordion',
  props: {
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    var props = __props;
    var prevAccordion = ref(null);
    var updatePrevAccordion = (a, _accordionItems) => {
      if (prevAccordion.value && _accordionItems && props.autoClose)
        //Deselecting any previously opened accordion
        _accordionItems[prevAccordion.value.id].active = false;
      //updating
      prevAccordion.value = a;
      if (_accordionItems) _accordionItems[a.id].active = true;
    };
    return (_ctx, _cache) => {
      return _renderSlot(_ctx.$slots, "default", {
        updatePrev: updatePrevAccordion,
        prev: prevAccordion.value
      });
    };
  }
});